import { MutationTree } from 'vuex';
import { InlineResponse200 as DevicesListResponse, V2Device } from 'ctp-search-device';
import {
  DEVICES_LIST_NAVIGATION,
  DevicesState,
  IDevicesStatePayload,
  SEARCH_DEVICES,
  QUERY_NUMBER_OF_ACTIVE_DEVICES,
  REINIT,
  TRIGGER_DEVICE_USER_SELECTION_ACTION,
  UPDATE_DEVICES_LIST_STATE,
  UPDATE_NAVIGATION,
  USER_SELECTION_CLEAR_DEVICES,
  USER_SELECTION_REGISTER_DEVICE,
  USER_SELECTION_RESET_ACTIONS,
  FETCH_SUGGESTIONS,
  QUERY_DEVICES_HISTORY,
  QUERY_DEVICES_TOLL_DOMAINS_NAMES
} from './types';

const mutations: MutationTree<DevicesState> = {
  [REINIT](state: DevicesState) {
    state.devices.navigation.filters = {};
    state.devices.navigation.start = 0;
    state.userSelection.devices = [];
  },
  [DEVICES_LIST_NAVIGATION](state: DevicesState, { direction }) {
    const incrementValues: any = {
      forward: state.devices.navigation.devicesPerPage,
      backward: state.devices.navigation.devicesPerPage * -1
    };

    state.devices.navigation.start += incrementValues[direction];
  },
  [USER_SELECTION_REGISTER_DEVICE](state: DevicesState, deviceId: string) {
    const userSelectionDevices = state.userSelection.devices;
    if (!userSelectionDevices.includes(deviceId)) {
      state.userSelection.devices.push(deviceId);
    } else {
      state.userSelection.devices = userSelectionDevices.filter(e => e !== deviceId);
    }
  },
  [USER_SELECTION_RESET_ACTIONS](state: DevicesState) {
    Object.keys(state.userSelection.actions).forEach((e) => {
      state.userSelection.actions[e].enabled = false;
    });
  },
  [TRIGGER_DEVICE_USER_SELECTION_ACTION](state: DevicesState, action: string) {
    if (Object.keys(state.userSelection.actions).includes(action)) {
      state.userSelection.actions[action].enabled = true;
    }
  },
  [USER_SELECTION_CLEAR_DEVICES](state: DevicesState) {
    state.userSelection.devices = [];
  },
  [UPDATE_DEVICES_LIST_STATE](
    state: DevicesState,
    stateToUpdate: IDevicesStatePayload
  ) {
    const {
      view,
      stateKey,
      stateValue
    } = stateToUpdate;
    if (view === 'devicesHistory') {
      state.devicesListComponentsState[stateKey][view] = {
        ...state.devicesListComponentsState[stateKey][view],
        [stateValue.deviceId]: stateValue.state
      };
    } else {
      state.devicesListComponentsState[stateKey][view] = stateValue;
    }
  },
  [UPDATE_NAVIGATION](state: DevicesState, payload) {
    state.devices.navigation = payload;
  },
  [SEARCH_DEVICES](state: DevicesState, res: DevicesListResponse) {
    const devices = res.devices?.devices as V2Device[];
    state.devices.devicesList = devices;
    state.devices.total = res.devices!.total!;
  },
  [QUERY_NUMBER_OF_ACTIVE_DEVICES](state: DevicesState, { numberOfActiveDevices }) {
    state.devices.numberOfActiveDevices = numberOfActiveDevices;
  },
  [FETCH_SUGGESTIONS](state: DevicesState, payload) {
    state.suggestions = payload;
  },
  [QUERY_DEVICES_HISTORY](state: DevicesState, payload) {
    const found = state.devices.devicesHistory.findIndex(elem => elem === payload);
    if (found === -1) {
      state.devices.devicesHistory = state.devices.devicesHistory.concat(payload);
    } else {
      state.devices.devicesHistory[found] = payload;
    }
  },
  [QUERY_DEVICES_TOLL_DOMAINS_NAMES](state: DevicesState, payload) {
    const found = state.devices.devicesTollDomainsNames.findIndex(elem => elem.deviceID === payload.deviceID);
    if (found === -1) {
      state.devices.devicesTollDomainsNames = state.devices.devicesTollDomainsNames.concat(payload);
    } else {
      state.devices.devicesTollDomainsNames[found] = payload;
    }
  }
};
export default mutations;
